<template>
  <div>
    <div class="case_div">
      <img class="home_banner" src="../../static/img/img_callus_bg.png" />
      <!-- <div class="div_top_title">
        <p>联系我们</p>
        <p class="p_title_sub">CONTACT US</p>
      </div> -->
      <div class="tip-div" id="info">
        <div class="tip-item">
          <img src="../../static/img/ic_callus_1.png"/>
          <p class="tip-title">安保服务专线</p>
          <p class="tip-num">400-687-7123</p>
        </div>
        <div class="tip-item">
          <img src="../../static/img/ic_callus_2.png"/>
          <p class="tip-title">公司邮箱</p>
          <p class="tip-subtitle">Hongbangbaoan@163.com</p>
        </div>
        <div class="tip-item">
          <img src="../../static/img/ic_callus_3.png"/>
          <p class="tip-title">公司地址</p>
          <p class="tip-subtitle">
            浙江省宁波市北仑区庐山西路90弄28号人力资源大厦9F
          </p>
        </div>
      </div>
    </div>
    <div class="father-div">
      <div id="baidumap" class="map_div"></div>

      <div class="heading" id="callus">在线留言</div>
      <!-- <ShowLine></ShowLine> -->
      <div class="father_div">
        <div class="father_sub_div">
          <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 elcol"> -->
          <div class="right_div">
            <el-form
              :label-position="labelPosition"
              label-width="80px"
              :model="dataForm"
              :rules="rules"
              ref="ruleForm"
            >
              <el-row :gutter="50">
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                  <el-form-item label="联系人" class="text" prop="name">
                    <el-input
                      v-model="dataForm.name"
                      placeholder="请输入您的名称"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12"
                  ><el-form-item label="联系电话" class="text" prop="tel">
                    <el-input
                      v-model="dataForm.tel"
                      placeholder="请输入您的联系电话"
                    ></el-input> </el-form-item
                ></el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :xs="24" :sm="24" :md="12" :lg="12">
                  <el-form-item label="联系邮箱" class="text" prop="email">
                    <el-input
                      v-model="dataForm.email"
                      placeholder="请输入您的联系邮箱"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="12" :lg="12"
                  ><el-form-item label="联系地址" class="text" prop="country">
                    <el-input
                      v-model="dataForm.country"
                      placeholder="请输入您的联系地址"
                    ></el-input> </el-form-item
                ></el-col>
              </el-row>
              <el-row :gutter="50">
                <el-col :xs="24" :sm="24" :md="24" :lg="24">
                  <el-form-item label="留言内容" class="text" prop="message">
                    <el-input
                      v-model="dataForm.message"
                      type="textarea"
                      placeholder="请输入您详细的需求内容"
                      :rows="rows"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>

            <div class="back-div">
              <p @click="onSubmit()">提交内容</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- </div> -->
</template>
<script>
import ShowLine from "../components/ShowLine.vue";
export default {
  components: {
    ShowLine,
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      console.log(to.path);
      var param = this.$route.query.param;
    if(param){
      console.log("param:" + param);
      this.navtoPartPath(param);
    }else{
      window.scrollTo(0, 0);
    }
    },
    
  },
  data() {
    return {
      dataForm: {
        id: 0,
        name: "",
        company: "",
        country: "",
        email: "",
        industry: "",
        tel: "",
        message: "",
      },
      labelPosition: "top",
      formLabelAlign: {
        name: "",
        file: "",
      },
      rows: 5,
      rules: {
        name: [
          { required: true, message: "请输入您的名称", trigger: "change" },
        ],

        tel: [
          { required: true, message: "请输入您的联系电话", trigger: "change" },
        ],
        email: [
          { required: true, message: "请输入您的联系邮箱", trigger: "change" },
        ],
        country: [
          { required: true, message: "请输入您的联系地址", trigger: "change" },
        ],
        message: [
          {
            required: true,
            message: "请输入您详细的需求内容",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    var param = this.$route.query.param;
    if(param){
      console.log("param:" + param);
      this.navtoPartPath(param);
    }else{
      window.scrollTo(0, 0);
    }
    window.addEventListener("scroll", this.scrollToTop);
    this.initMap();
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    navtoPartPath(path) {
      setTimeout(() => {
        document.getElementById(path).scrollIntoView();
      }, 500);
    },
    initMap() {
      var map = new BMap.Map("baidumap", {
        enableBizAuthLogo: false,
      });
      var point = new BMap.Point(121.792433, 29.914242);
      map.enableScrollWheelZoom(true);
      map.centerAndZoom(point, 17);
      map.addEventListener("zoomend", function () {
        // alert("地图缩放至：" + this.getZoom() + "级");
        map.panTo(new BMap.Point(121.792433, 29.914242));
      });
      window.setTimeout(function () {
        map.panTo(new BMap.Point(121.792433, 29.914242));
      }, 2000);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
    },
    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.dataFormSubmit();
          console.log("submit!");
          this.clearForm();
        }
      });
    },
    clearForm() {
      this.dataForm.company = "";
      this.dataForm.name = "";
      this.dataForm.tel = "";
      this.dataForm.email = "";
      this.dataForm.industry = "";
      this.dataForm.country = "";
      this.dataForm.message = "";
    },
    // 表单提交
    dataFormSubmit() {
      this.$axios
        .post(
          "api/visitormessage/save",
          JSON.stringify({
            company: this.dataForm.company,
            industry: this.dataForm.industry,
            email: this.dataForm.email,
            country: this.dataForm.country,
            name: this.dataForm.name,
            tel: this.dataForm.tel,
            message: this.dataForm.message,
          }),
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
            },
          }
        )
        .then(
          function (response) {
            var status = response.data.code;
            if (status === 0) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
            }
          }.bind(this)
        );
    },
  },
};
</script>
<style lang="stylus" scoped>
.father-div {
  width: 60vw;
  margin: auto;
  padding: 14rem 0 10rem 0;
}

.tip-div {
  position: absolute;
  bottom: -8rem;
  right: 0;
  left: 0;
  background: white;
  padding: 3rem 0;
  margin: auto;
  width: 70vw;
  box-shadow: 3px 3px 10px 1px rgba(100, 100, 100, 0.1);
  border-radius: 6px;
  display: flex;
  justify-content: space-evenly;

  .tip-item {
    text-align: center;
    img{
      width:6rem;
      height:6rem;
    }
    .tip-title {
      color: var(--COLORE47);
      font-family: regular;
      font-size: 2rem;
      margin-top:2rem;
    }

    .tip-subtitle {
      color: var(--COLORE47);
      font-family: bold;
      font-size: 2rem;
      margin-bottom: 0;
    }

    .tip-num {
      color: var(--COLORE47);
      font-family: DIN-Bold;
      font-size: 2.2rem;
      margin-bottom: 0;
      line-height:2;
    }
  }
}

.case_div {
  height: 100%;
  position: relative;
}

.home_banner {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: var(--textBlue);

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.cover_div {
  display: block;
  position: absolute;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.5) 0);
  top: 0;
  left: 0;
}

.div_top_title {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  width: 50%;
  height: 100%;
  left: 0;
  top: 0;
  color: white;
  font-size: 4rem;
  font-family: medium;

  p {
    margin-bottom: 0;
    user-select: none;
  }

  .p_title_sub {
    position: absolute;
    font-size: 8rem;
    font-family: DIN-Bold;
    margin: 0 1rem;
    color: var(--textWhiteColor20);
  }

  .litter_line_top {
    margin: auto;
    background-color: white;
    height: 1px;
    width: 20%;
  }
}

.map_div {
  height: 52rem;
}

.back-div {
  cursor: pointer;
  margin-top: 8rem;
  width: 15rem;
  border-radius: 5rem;
  color: white;
  background: var(--COLORE14B3E3);
  padding: 0.5rem 0;
  display: flex;
  justify-content: center;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);

  p {
    margin: 0;
    font-size: 1.8rem;
  }
}

.heading {
  padding: 7rem 0 0 0;
  font-size: 3rem;
  color: var(--COLORE17);
  text-align: left;
  font-family: bold;
}

.father_div {
  width: 100%;
}

.father_sub_div {
  padding: 2rem 0;
}

.left_div {
  height: 50vw;
}

.right_div {
  height: auto;
}

.title {
  font-size: 25px;
  margin: 30px 0;
  color: #F3C23E;
}

.contain {
  font-size: 1.5rem;
  line-height: 3rem;
  text-align: left;
}

.contain_tv1 {
  font-size: 1.5rem;
  font-family: bold;
  margin: 0;
  text-align: left;
}

.contain_tv2 {
  font-family: bold;
  font-size: 2.5rem;
  margin: 0;
  text-align: left;
}

.contain_img {
  width: 6rem;
  height: 6rem;
}

.demo-form-inline {
  margin-top: 30px;
}

.inputbox {
  display: flex;

  div {
    font-size: 14px;
    margin-right: 20px;
  }
}

.btnbox {
  text-align: center;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
}

.flex-container > div {
  padding: 20px;
}

.litter_line {
  margin: 2rem 0;
  background-color: black;
  height: 1px;
  width: 50%;
}

/deep/ .el-form-item__label {
  color: var(--COLORE3B);
  font-size: 2rem;
  font-family: regular;
  display: block !important;
  // padding: 0;
  margin: 0;
}

/deep/ .el-input__inner {
  background-color: var(--COLOREFB);
  border-color: var(--COLOREC2);
  border-radius: 0;
  color: var(--COLORE3B);
  font-size: 2rem;
  font-family: regular;
}

/deep/ .el-input__inner:hover {
  border-color: var(--COLOREC2);
}

/deep/ .el-textarea__inner {
  background-color: var(--COLOREFB);
  border-color: var(--COLOREC2);
  border-radius: 0;
  color: var(--COLORE3B);
  font-size: 2rem;
  font-family: regular;
}

input {
  color: #3c3c3c !important;
}

.input-group {
  width: 100%;
  height: 5rem;
  margin: 0.5rem 0;
}

.input-group .form-control {
  height: 100%;
  width: 100%;
  border-radius: 0;
  border: none;
}

.input-group-addon {
  background-color: #fff;
  border: 0;
  border-radius: 0;
}

.msg_input {
  width: 100% !important;
  height: 30rem;
}

.my_btn_group {
  margin: auto;
  margin-top: 1rem;
  width: 50%;
}

.btn-group {
  margin: auto;
  margin-top: 1rem;
  width: 100%;
  text-align: center;
}

.btn-default {
  padding-left: 2rem;
  padding-right: 2rem;
  border-color: #000;
  border-radius: 0;
  margin: 2rem 1rem;
  text-align: center;
}

.btn-default:hover {
  border-color: var(--textBlue);
  background-color: var(--textBlue);
  color: #fff;
}

@media (max-width: 1450px) {
  .father_div {
    //height: 100vh;
  }
}

@media (max-width: 1100px) {
}

@media (max-width: 800px) {
  .home_banner {
    width: 100%;
  }

  .father_div {
    //height: 100vh;
  }

  .father_sub_div {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .left_div {
    height: 60vw;
  }

  .right_div {
    //height: 100vw;
    margin-rignt: 1rem !important;
  }
}
@media screen and (max-width: 1200px) {
  .tip-div{
    display: flex;
    flex-direction: column;
    position: relative;
  }
  .father-div{
    width:95vw;
  }
}
</style>
